export const REGEX_MAIL =
  '^(?!.*(?:\\.-|-\\.))[^@]+@[^\\W_](?:[\\w-]*[^\\W_])?(?:\\.[^\\W_](?:[\\w-]*[^\\W_])?)+$';
export const REGEX_SPLIT_BY_UPPER_CASE_LETTER = /(?=[A-Z])/;

export const IS_MOBILE_NAVIGATOR = /iPhone|iPad|iPod|Android/.test(navigator.userAgent);

export const REGEX_ALPHANUMERIC = /[^\dA-Za-z]+/g;

export const ALPHANUMERIC_MASK = Array(50).fill(/[a-zA-Z0-9\s]/);
